// extracted by mini-css-extract-plugin
export default {"playerSection":"PlayerSection_playerSection__5ADnV","playersContainer":"PlayerSection_playersContainer__qTt6K"};